import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import secondModule from './secondModule'
import VuexPersistence from 'vuex-persist';
import localForage from 'localforage';
localForage.config({
  name: "uajy",
  version: 1.0,
  storeName: "uajy", // Should be alphanumeric, with underscores.
});
const vuexStorage = new VuexPersistence({
    key: 'BimbinganUAJY',
    storage: localForage,
    reducer: state => ({ auth: state.auth }),
    asyncStorage: true
  })
const vuexStorageUser = new VuexPersistence({
    key: 'BimbinganUAJY-users',
    storage: localForage,
    reducer: state => ({ kaprodi: state.kaprodi, mahasiswa: state.mahasiswa,dosen: state.dosen, transcriptData: state.transcriptData, sidebar: state.sidebar}),
    asyncStorage: true
  })
const vuexStorageMasterData = new VuexPersistence({
    key: 'BimbinganUAJY-master',
    storage: localForage,
    reducer: state => ({announcement: state.announcement, studyProgram: state.studyProgram, studySession: state.studySession,studyCourse: state.studyCourse, semester: state.semester, setting: state.setting  }),
    asyncStorage: true
  })
  const vuexStorageMasterData2 = new VuexPersistence({
    key: 'BimbinganUAJY-master-2',
    storage: localForage,
    reducer: state => ({ yudisiumGroup: state.yudisiumGroup}),
    asyncStorage: true
  })
const vuexStorageGuidanceData = new VuexPersistence({
    key: 'BimbinganUAJY-guidance',
    storage: localForage,
    reducer: state => ({ guidance: state.guidance, thesis: state.thesis, advisor: state.advisor, internship: state.internship }),
    asyncStorage: true
  })
const vuexStorageChat = new VuexPersistence({
    key: 'BimbinganUAJY-chatData',
    storage: localForage,
    reducer: state => ({ chat: state.chat }),
    asyncStorage: true
  })
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem('appkey'),
    subs: !!localStorage.getItem('subs'),
    role: localStorage.getItem('BimbinganUAJY-role'),
    activeTab: 'Dashboard',
    snackbar: {
      type: "success",
      text: "message",
      withclose: true,
      show: false
    },
    breadcrumb: [],
    loading: 0,
    collapse: false,
    modal: null
  },
  getters: {
    getLoading: state => state.loading,
    getisLoggedIn: state => state.isLoggedIn,
    getSubs: state => state.subs,
    getRole: state => state.role,
    getActiveTab: state => state.activeTab,
    getSnackbar: state => state.snackbar,
    getBreadcrumb: state => state.breadcrumb,
    getCollapse: state => state.collapse,
    getModal: state => state.modal
  },
  actions: {
    setActiveTab({commit}, value){
      commit('SET_ACTIVETAB', value)
    },
    setBreadCrumb({commit}, value){
      commit('SET_BREADCRUMB', value)
    },
    setModal({state}, value){
      state.modal = value
    },
    setLoading({commit}, value){
      commit('SET_LOADING', value);
    },
    showSnackbar({commit}, {
        type = "success",
        text = "message",
        withclose = true,
        show = true
      }){
        var value ={
          type: type,
          text: text,
          withclose: withclose,
          show: show
        }
      commit('SET_SNACKBAR', value);
    },
    hideSnackbar({commit}){
        commit('HIDE_SNACKBAR');
    },
    logoutStorage({commit,state}){
      localStorage.clear();
      state.isLoggedIn = false
      const initial = modules
      Object.keys(initial).forEach(key =>  commit(`${key}/resetState`))
    }
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_ACTIVETAB(state, value) {
      state.activeTab = value;
    },
    SET_SNACKBAR(state, value) {
      state.snackbar = value;
    },
    HIDE_SNACKBAR(state) {
      state.snackbar.show = false;
    },
    SET_BREADCRUMB(state, value) {
      state.breadcrumb = value;
    },
    SET_COLLAPSE(state) {
      state.collapse = !state.collapse;
    },
    RESET_COLLAPSE(state) {
      state.collapse = false;
    },
  },
  modules: {
    ...modules,
    ...secondModule
  },
  plugins: [vuexStorage.plugin, vuexStorageUser.plugin, vuexStorageMasterData.plugin,vuexStorageMasterData2.plugin, vuexStorageChat.plugin, vuexStorageGuidanceData.plugin]
})